import { render, staticRenderFns } from "./SectionUploadFile.vue?vue&type=template&id=da844384&scoped=true&"
import script from "./SectionUploadFile.vue?vue&type=script&lang=ts&"
export * from "./SectionUploadFile.vue?vue&type=script&lang=ts&"
import style0 from "./SectionUploadFile.vue?vue&type=style&index=0&id=da844384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da844384",
  null
  
)

export default component.exports